/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const beforeAfterCountSchema = z.object({
  after: z.int(),
  before: z.int(),
  change: z.int(),
});
